// extracted by mini-css-extract-plugin
export default {"buttons":"GenericNftCreateModalContent_buttons__eNLR2","mediaUpload":"GenericNftCreateModalContent_mediaUpload__X4qnM","subtitle":"GenericNftCreateModalContent_subtitle__vHzO-"};